import React from "react";
import PowerBi from "@pages/PowerBi";

/**
 * MyTeams Component
 * 
 * Displays My Team Power BI dashboard showing team-related analytics and insights.
 */
const MyTeams = () => {
  return (
    <div className="w-auto px-2 py-2.5 rounded-lg lg:px-6">
      <div className="py-2.5 text-[#3901FF] font-semibold text-xl leading-5">
        My Team
      </div>
      <PowerBi
        id="7d086498-f679-4a6b-b1bf-892ad94f12f7"
        pageName={{
          id: "249647d9a88019e28db5",
          name: "My Team",
        }}
      />
    </div>
  );
};

export default MyTeams;
